import React, { useEffect } from 'react';

export interface IModalChildProps {
    onClose: () => void;
    onAccept: () => void;
}

interface IModalProps {
    children: JSX.Element;
}

const Modal = ({ children }: IModalProps) => {
    const body = document.body;
    const background = document.createElement('div');

    useEffect(() => {
        background.className = 'modal-backdrop fade in';
        if (!body.classList.contains('modal-open')) {
            body.classList.add('modal-open');
            body.appendChild(background);
            body.style.paddingRight = '17px';
        }

        return () => {
            if (body.classList.contains('modal-open')) {
                body.classList.remove('modal-open');
                body.style.paddingRight = '';
                if (body.contains(background)) {
                    body.removeChild(background);
                }
            }
        };
    }, []);

    return (
        <div
            className="modal fade in"
            style={{ display: 'block', overflow: 'scroll' }}
        >
            <div className="modal-dialog">
                <div className="modal-content">{children}</div>
            </div>
        </div>
    );
};

export default Modal;
